import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { DateRange } from "@/hooks/useSearchFilters";
interface ActiveFiltersProps {
  filters: string[];
  distance: number;
  rating: number;
  query: string;
  dateRange?: DateRange;
  availablePortions: number;
  deliveryOnly: boolean;
  onRemoveFilter: (filter: string) => void;
  onClearQuery: () => void;
  onClearDeliveryOnly: () => void;
  onClearDistance: () => void;
  onClearRating: () => void;
  onClearPortions: () => void;
  onClearDateRange: () => void;
}
export const ActiveFilters = ({
  filters,
  distance,
  rating,
  query,
  dateRange,
  availablePortions,
  deliveryOnly,
  onRemoveFilter,
  onClearQuery,
  onClearDeliveryOnly,
  onClearDistance,
  onClearRating,
  onClearPortions,
  onClearDateRange
}: ActiveFiltersProps) => {
  if (!(filters.length > 0 || query || dateRange || availablePortions > 1 || deliveryOnly || distance > 0 || rating > 0)) {
    return null;
  }
  return <div className="container mx-auto py-[8px] px-[3px]">
      <div className="flex flex-wrap gap-2">
        {filters.map(filter => <Badge key={filter} variant="secondary" className="flex items-center gap-1">
            {filter}
            <X className="h-3 w-3 cursor-pointer" onClick={() => onRemoveFilter(filter)} />
          </Badge>)}
        {query && <Badge variant="secondary" className="flex items-center gap-1">
            {query}
            <X className="h-3 w-3 cursor-pointer" onClick={onClearQuery} />
          </Badge>}
        {deliveryOnly && <Badge variant="secondary" className="flex items-center gap-1">
            Available for delivery
            <X className="h-3 w-3 cursor-pointer" onClick={onClearDeliveryOnly} />
          </Badge>}
        {distance > 0 && <Badge variant="secondary" className="flex items-center gap-1">
            Within {distance} miles
            <X className="h-3 w-3 cursor-pointer" onClick={onClearDistance} />
          </Badge>}
        {rating > 0 && <Badge variant="secondary" className="flex items-center gap-1">
            {rating}+ Stars
            <X className="h-3 w-3 cursor-pointer" onClick={onClearRating} />
          </Badge>}
        {availablePortions > 1 && <Badge variant="secondary" className="flex items-center gap-1">
            Min {availablePortions} portions
            <X className="h-3 w-3 cursor-pointer" onClick={onClearPortions} />
          </Badge>}
        {dateRange?.from && <Badge variant="secondary" className="flex items-center gap-1">
            {format(dateRange.from, 'MMM d')}
            {dateRange.to && dateRange.to.getTime() !== dateRange.from.getTime() && ` - ${format(dateRange.to, 'MMM d')}`}
            <X className="h-3 w-3 cursor-pointer" onClick={onClearDateRange} />
          </Badge>}
      </div>
    </div>;
};